import React from 'react';
import { TourSearch } from '../../../components';

export default function ToursTab() {
  return <TourSearch />;
}
